import React from 'react';
import Web3 from 'web3';
import BI from 'big-integer';
import BN from 'bignumber.js';
import RTZ from 'remove-trailing-zeros'

import SyncLoader from "react-spinners/SyncLoader";
import { SupportedTokens, SwapContracts, SwapContractABI, TokenContractABI } from "../../Data/ContractData";

import "./swapCreate.css";

class SwapCreate extends React.Component {

  /*
    tokenSelected
    0 : APIX
    1 : wDASH
    2 : wXZC
  */
  /*
    tokenSelected v2
    0 : APIX
    1 : WETH
    2 : wDASH
  */


  constructor(props) {
    super(props);

    this.state = {
      isMetamaskConnected: false,
      isSwapDataLoaded: false,

      userAccount: "",
      fromTokenIndex: 0,
      toTokenIndex: 0,

      requirements: {
        creatorBalance: 0,
        creatorAllowance: 0,
        checkResult: [true, true],
      },

      fromTokenInput: "",
      toTokenInput: "",
      fromTokenFixed: "0",
      toTokenFixed: "0",

      swapPair: 0,
    }
  }

  web3 = null;

  tokenInfo = [
    {
      tokenName: "APIX",
      tokenIcon: "tokenicon_apix.svg"
    },
    {
      tokenName: "WETH",
      tokenIcon: "tokenicon_weth.svg"
    },
    {
      tokenName: "wDASH",
      tokenIcon: "tokenicon_dash.svg"
    },
    /*
    {
      tokenName: "wXZC",
      tokenIcon: "tokenicon_xzc.svg"
    },
    */
  ]

  /*
  pairInfo = [
    {
      tokenNameFrom: "APIX",
      tokenNameTo: "wDASH",
      tokenIconFrom: "tokenicon_apix.svg",
      tokenIconTo: "tokenicon_dash.svg",
    },
    {
      tokenNameFrom: "APIX",
      tokenNameTo: "wXZC",
      tokenIconFrom: "tokenicon_apix.svg",
      tokenIconTo: "tokenicon_xzc.svg",
    },
    {
      tokenNameFrom: "wDASH",
      tokenNameTo: "APIX",
      tokenIconFrom: "tokenicon_dash.svg",
      tokenIconTo: "tokenicon_apix.svg",
    },
    {
      tokenNameFrom: "wDASH",
      tokenNameTo: "wXZC",
      tokenIconFrom: "tokenicon_dash.svg",
      tokenIconTo: "tokenicon_xzc.svg",
    },
    {
      tokenNameFrom: "wXZC",
      tokenNameTo: "APIX",
      tokenIconFrom: "tokenicon_xzc.svg",
      tokenIconTo: "tokenicon_apix.svg",
    },
    {
      tokenNameFrom: "wXZC",
      tokenNameTo: "wDASH",
      tokenIconFrom: "tokenicon_xzc.svg",
      tokenIconTo: "tokenicon_dash.svg",
    },
  ]
  */

  pairInfo = [
    {
      tokenNameFrom: "APIX",
      tokenNameTo: "WETH",
      tokenIconFrom: "tokenicon_apix.svg",
      tokenIconTo: "tokenicon_weth.svg",
    },
    {
      tokenNameFrom: "APIX",
      tokenNameTo: "wDASH",
      tokenIconFrom: "tokenicon_apix.svg",
      tokenIconTo: "tokenicon_dash.svg",
    },
    {
      tokenNameFrom: "WETH",
      tokenNameTo: "APIX",
      tokenIconFrom: "tokenicon_weth.svg",
      tokenIconTo: "tokenicon_apix.svg",
    },
    {
      tokenNameFrom: "WETH",
      tokenNameTo: "wDASH",
      tokenIconFrom: "tokenicon_weth.svg",
      tokenIconTo: "tokenicon_dash.svg",
    },
    {
      tokenNameFrom: "wDASH",
      tokenNameTo: "APIX",
      tokenIconFrom: "tokenicon_dash.svg",
      tokenIconTo: "tokenicon_apix.svg",
    },
    {
      tokenNameFrom: "wDASH",
      tokenNameTo: "WETH",
      tokenIconFrom: "tokenicon_dash.svg",
      tokenIconTo: "tokenicon_weth.svg",
    },
  ]

  CC = (val) => {
    val = String(val);
    let temp = BI(val).divmod("1000000000000000000");
    let apt = temp.remainder.toString();
    let aptLen = apt.length;

    for (let i = 0; i < 18 - aptLen; i++) {
      apt = "0" + apt;
    }

    let xpt = [temp.quotient.toString(), apt]
    return RTZ(xpt[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (xpt[1] ? "." + xpt[1] : ""));
  }

  loadSwapDetail = async () => {

    let selectedSwapPair = 0;
    /*old
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wXZC") selectedSwapPair = 1;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "wDASH-wXZC") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wXZC-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wXZC-wDASH") selectedSwapPair = 5;
    */

    if (this.props.match.params.pair === "APIX-WETH") selectedSwapPair = 0;
    if (this.props.match.params.pair === "APIX-wDASH") selectedSwapPair = 1;
    if (this.props.match.params.pair === "WETH-APIX") selectedSwapPair = 2;
    if (this.props.match.params.pair === "WETH-wDASH") selectedSwapPair = 3;
    if (this.props.match.params.pair === "wDASH-APIX") selectedSwapPair = 4;
    if (this.props.match.params.pair === "wDASH-WETH") selectedSwapPair = 5;

    this.setState({
      swapPair: selectedSwapPair,
      isSwapDataLoaded: true,
    })

    this.loadTokenDetail();
  }

  loadTokenDetail = async () => {

    let fromTokenIndex = 0;
    let toTokenIndex = 1;

    if (this.state.swapPair === 0) {
      fromTokenIndex = 0;
      toTokenIndex = 1;
    }
    if (this.state.swapPair === 1) {
      fromTokenIndex = 0;
      toTokenIndex = 2;
    }
    if (this.state.swapPair === 2) {
      fromTokenIndex = 1;
      toTokenIndex = 0;
    }
    if (this.state.swapPair === 3) {
      fromTokenIndex = 1;
      toTokenIndex = 2;
    }
    if (this.state.swapPair === 4) {
      fromTokenIndex = 2;
      toTokenIndex = 0;
    }
    if (this.state.swapPair === 5) {
      fromTokenIndex = 2;
      toTokenIndex = 1;
    }


    let fromTokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[fromTokenIndex].contractAddr);
    let toTokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[toTokenIndex].contractAddr);

    /*
      totoken & fromtoken is based on TAKER'S VIEW!!!!!!!!!!!!!!!!!!!!
      totoken & fromtoken is based on TAKER'S VIEW!!!!!!!!!!!!!!!!!!!!
      totoken & fromtoken is based on TAKER'S VIEW!!!!!!!!!!!!!!!!!!!!
    */

    let creatorBalance = await toTokenContract.methods.balanceOf(this.state.userAccount).call();
    let creatorAllowance = await toTokenContract.methods.allowance(this.state.userAccount, SwapContracts[this.state.swapPair].contractAddr).call();


    this.setState({
      fromTokenIndex,
      toTokenIndex,

      requirements: {
        creatorBalance: creatorBalance,
        creatorAllowance: creatorAllowance,
        checkResult: this.state.requirements.checkResult
      },

      isSwapDataLoaded: true,
    })
  }

  getSwapStatus = () => {
    //isSwapCancelled: false,
    //isSwapFinished: false,
    //isSwapOpened: true,

    if (this.state.swapDetail.isSwapCancelled) {
      return "Cancelled ❌"
    }
    if (this.state.swapDetail.isSwapFinished) {
      return "Finished ❌"
    }
    if (this.state.swapDetail.isSwapOpened) {
      return "Opened ✔️"
    }
    else {
      return "N/A"
    }
  }

  changeAllowance = async (mode, target) => {
    let swapContractAddress = SwapContracts[this.state.swapPair].contractAddr;
    let tokenContract = null;
    let modifiedValue = null;

    if (target === "FROM") {
      tokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[this.state.fromTokenIndex].contractAddr);
    } else if (target === "TO") {
      tokenContract = new this.web3.eth.Contract(TokenContractABI, SupportedTokens[this.state.toTokenIndex].contractAddr);
    }

    //console.log(this.state.fromTokenFixed);
    //console.log(this.state.toTokenFixed);

    if (mode === "APPLY" && target === "FROM") {
      modifiedValue = Math.ceil(Number(this.state.fromTokenFixed));
      modifiedValue = BI(modifiedValue).multiply(10 ** 18);
    } else if (mode === "APPLY" && target === "TO") {
      modifiedValue = Math.ceil(Number(this.state.toTokenFixed));
      modifiedValue = BI(modifiedValue).multiply(10 ** 18);
    } else if (mode === "REMOVE") {
      modifiedValue = "0"
    }
    let result = await (tokenContract.methods.approve(swapContractAddress, String(modifiedValue)).send({
      from: this.state.userAccount
    }));
    console.log(result);
  }

  isNumberKey = (e) => {
    let regExp = /^\d*(\.\d{0,18})?$/;
    if (e.target.value.search(regExp) === -1) {
      return false;
    } else {
      return true;
    }
  }

  handleTokenInputChange = (e) => {
    if (e.target.id === "fromInput") {
      if (this.isNumberKey(e) && Number(e.target.value) < 1000000000000000) {
        this.setState({
          fromTokenInput: e.target.value
        })
      }
    } else {
      if (this.isNumberKey(e) && Number(e.target.value) < 1000000000000000) {
        this.setState({
          toTokenInput: e.target.value
        })
      }
    }
  }

  applySwapData = () => {

    if (this.state.fromTokenInput === "") {
      return;
    }
    if (this.state.toTokenInput === "") {
      return;
    }

    this.loadTokenDetail();

    let tmpCheckResult = [false, false]
    let tmpReq = this.state.requirements;

    if (Number(this.state.requirements.creatorBalance) / (10 ** 18) >= Number(this.state.toTokenInput)) { //balance
      tmpCheckResult[0] = true;
    }
    if (Number(this.state.requirements.creatorAllowance) / (10 ** 18) >= Number(this.state.toTokenInput)) { //allowance
      tmpCheckResult[1] = true;
    }

    tmpReq.checkResult = tmpCheckResult;

    this.setState({
      fromTokenFixed: new BN(this.state.fromTokenInput).toString(),
      toTokenFixed: new BN(this.state.toTokenInput).toString(),
      requirements: tmpReq
    })
  }

  bigintToString = (bignum, digit) => {
    let digited = bignum.times(10**digit);
    return (digited.toString());

    /*
    let dummy = "";
    let tmpFFF = new BN(10**digit);
    let fpgd = bigint.times(10**digit);

    console.log(bigint);
    console.log(fpgd);
    console.log(fpgd.toString())

    console.log("DSFSDFSD")

    if (bigint.e < 0) {
      for (let i = 0; i < digit - (String(bigint.c[0]).length); i++) {
        dummy += "0"
      }
      return (String(bigint.c[0]) + dummy);
    }

    if (bigint.c[1] === undefined) {
      for (let i = 0; i < digit; i++) {
        dummy += "0"
      }
      return (String(bigint.c[0]) + dummy);
    } else {
      for (let i = 0; i < digit - (String(bigint.c[1]).length); i++) {
        dummy += "0"
      }
      return (String(bigint.c[0]) + String(bigint.c[1]) + dummy);
    }
    */
  }

  createSwapOrder = async () => {
    //totoken : creator will send
    //fromtoken : taker will send

    ////console.log(this.state.fromTokenIndex);
    //console.log("fromtoken- in contract: totoken")
    //console.log(this.tokenInfo[this.state.fromTokenIndex].tokenName);

    ////console.log(this.state.toTokenIndex);
    //console.log("totoken- in contract: fromtoken")
    //console.log(this.tokenInfo[this.state.toTokenIndex].tokenName);

    let ttf = new BN(this.state.toTokenFixed);
    let ftf = new BN(this.state.fromTokenFixed);

    console.log(ttf);
    console.log(ftf);

    console.log(this.tokenInfo[this.state.toTokenIndex].tokenName);
    console.log(this.bigintToString(ttf, 18));

    console.log(this.tokenInfo[this.state.fromTokenIndex].tokenName);
    console.log(this.bigintToString(ftf, 18));

    let swapContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[this.state.swapPair].contractAddr);
    let result = await swapContract.methods.createSwapOrder(this.bigintToString(ttf, 18), this.bigintToString(ftf, 18)).send({
      from: this.state.userAccount
    })
    
    console.log(result);

    /*
    let swapContract = new this.web3.eth.Contract(SwapContractABI, SwapContracts[this.state.swapPair].contractAddr);

    console.log(this.state.swapDetail.swapOrderID);

    let result = await(swapContract.methods.takeSwapOrder(this.state.swapDetail.swapOrderID).send({
      from: this.state.userAccount
    }))
    console.log(result);
    */
  }


  componentDidMount = () => {
    window.scrollTo(0, 0);

    this.web3 = new Web3(Web3.givenProvider);

    this.web3.eth.requestAccounts()
      .then((result) => {
        //console.log(result);
        this.setState({
          isMetamaskConnected: true,
          userAccount: result[0]
        })
        this.loadSwapDetail();
      })
      .catch((err) => {
        this.setState({
          isMetamaskConnected: false,
          userAccount: ""
        })
      })
  }

  renderButtons = (id) => {
    let buttons = [];
    for (let i = 0; i < this.tokenInfo.length; i++) {
      buttons.push(
        <div className="selectbox-button" onClick={() => { this.changeSelectedToken(id, i) }}>
          <img className="selectbox-button-icon" src={require("../../Asset/" + this.tokenInfo[i].tokenIcon)} />
          <p className="selectbox-button-text">{this.tokenInfo[i].tokenName}</p>
        </div>
      )
    }
    return buttons;
  }


  renderSwapBox = () => {
    return (
      <div className="APIS-swapcreatebox">
        <div className="APIS-swapcreatebox-top">
          <div className="APIS-swapcreatebox-1">
            <p className="APIS-swapcreatebox-tag">From (token to send)</p>
            <div className="APIS-swapcreatebox-selector">

              <div className="APIS-swapcreatebox-selector-2">
                <div className="APIS-swapcreatebox-tokenselector">
                  <div className="tokenselector-1">
                    <img className="tokenselector-icon" src={require("../../Asset/" + this.tokenInfo[this.state.toTokenIndex].tokenIcon)} />
                  </div>
                  <div className="tokenselector-2">
                    <p className="tokenselector-tokenname">{this.tokenInfo[this.state.toTokenIndex].tokenName}</p>
                  </div>
                </div>
              </div>
              <div className="APIS-swapcreatebox-selector-1">
                <input
                  id="toInput"
                  className="APIS-swapcreatebox-input"
                  placeholder="amount"
                  onChange={this.handleTokenInputChange}
                  value={this.state.toTokenInput}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>

          <div className="APIS-swapcreatebox-2">
            <img className="swap-icon" src={require("../../Asset/swap_icon.svg")} />
          </div>

          <div className="APIS-swapcreatebox-3">
            <p className="APIS-swapcreatebox-tag">To (token to receive)</p>
            <div className="APIS-swapcreatebox-selector">
              <div className="APIS-swapcreatebox-selector-2">
                <div className="APIS-swapcreatebox-tokenselector">
                  <div className="tokenselector-1">
                    <img className="tokenselector-icon" src={require("../../Asset/" + this.tokenInfo[this.state.fromTokenIndex].tokenIcon)} />
                  </div>
                  <div className="tokenselector-2">
                    <p className="tokenselector-tokenname">{this.tokenInfo[this.state.fromTokenIndex].tokenName}</p>
                  </div>
                </div>
              </div>
              <div className="APIS-swapcreatebox-selector-1">
                <input
                  id="fromInput"
                  className="APIS-swapcreatebox-input"
                  placeholder="amount"
                  onChange={this.handleTokenInputChange}
                  value={this.state.fromTokenInput}
                  autoComplete="off"
                />
              </div>
            </div>
          </div>

          <div className="APIS-swapcreatebox-4">
            <button className="APIS-swapcreatebox-swapbutton" onClick={() => { this.applySwapData() }}>
              Apply Data
          </button>
          </div>
        </div>
        <div className="APIS-swapcreatebox-bottom">
          <p className="APIS-swapcreatebox-bottomtext">
            By using the APIS Decentralized Swap service, you are agreeing to the
          <span className="APIS-swapcreatebox-bottomtext-tnc"> Terms and Conditions</span>
          </p>
        </div>
      </div>
    )
  }

  isCallOkay = () => {
    if (Number(this.state.toTokenFixed) === 0 || Number(this.state.fromTokenFixed) === 0) return "⚠️";
    if (!this.state.requirements.checkResult[0] || !this.state.requirements.checkResult[1]) return "⚠️";
  }

  render() {
    //let ftr = Number(Number(this.state.swapDetail.fromTokenAmount)/Number(this.state.swapDetail.toTokenAmount)).toFixed(10); //from : 1 - to : ftr
    //let tfr = Number(Number(this.state.swapDetail.toTokenAmount)/Number(this.state.swapDetail.fromTokenAmount)).toFixed(10); //to : 1 - from : tfr
    let fromToRatio = 0;
    let toFromRatio = 0;
    fromToRatio = Number(Number(this.state.toTokenFixed) / Number(this.state.fromTokenFixed)).toFixed(10); //to : 1 - from : tfr
    toFromRatio = Number(Number(this.state.fromTokenFixed) / Number(this.state.toTokenFixed)).toFixed(10); //from : 1 - to : ftr

    if (Number(this.state.toTokenFixed) === 0 || Number(this.state.fromTokenFixed) === 0) {
      fromToRatio = 0;
      toFromRatio = 0;
    }

    //totoken : sender will send
    //fromtoken : taker will send

    if (!this.state.isSwapDataLoaded) {
      return (
        <div className="APIS-swapdetail">
          <div className="APIS-swapcreate-container">
            <div className="APIS-swapdetail-loadingcontainer">
              <h1 className="APIS-swapcreate-loading">
                <span className="APIS-swap-intro-text-bold">
                  Loading Swap Creation Page...
                </span>
              </h1>
              <div className="APIS-swapcreate-spinner">
                <SyncLoader
                  size={30}
                  margin={10}
                  color={"#ffffff99"}
                  loading={true}
                />
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="APIS-swapcreate">
        <div className="APIS-swapcreate-container">
          <div className="APIS-swapcreate-content">
            <h1 className="APIS-swapcreate-head">
              <span className="APIS-swap-intro-text-bold">Create Swap Order</span> {this.props.match.params.pair}-v2
            </h1>
            <div className="swapcreate-info">
              <p className="swapcreate-title">Swap Information</p>
              <div className="swapcreate-datacontainer">
                <div className="swapcreate-datacontainer-1">
                  <p className="swapcreate-data"><span className="swapcreate-data-bold">Swap Pair</span> </p>
                  <p className="swapcreate-data"><span className="swapcreate-data-bold">Swap Contract</span></p>
                  <p className="swapcreate-data"><span className="swapcreate-data-bold">Contract Version</span> </p>
                </div>
                <div className="swapcreate-datacontainer-2">
                  <p className="swapcreate-data">{this.props.match.params.pair}</p>
                  <p className="swapcreate-data">{SwapContracts[this.state.swapPair].contractAddr}</p>
                  <p className="swapcreate-data">v2.0 - Ethereum</p>
                </div>
              </div>

              <p className="swapcreate-title">Swap Setup</p>
              {this.renderSwapBox()}

              <p className="swapcreate-title">Requirements & Summary</p>
              <div className="swapcreate-datacontainer">
                <div className="swapcreate-datacontainer-1">
                  <p className="swapcreate-data">
                    <span className="swapcreate-data-bold">Creator's {this.pairInfo[this.state.swapPair].tokenNameTo} Balance (Your {this.pairInfo[this.state.swapPair].tokenNameTo} Balance) : </span>
                    {this.CC(this.state.requirements.creatorBalance)} <span className="swapcreate-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                    {this.state.requirements.checkResult[0] ? "✔️" : "❌"}
                  </p>
                  <p className="swapcreate-data">
                    <span className="swapcreate-data-bold">Creator's {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance (Your {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance) : </span>
                    {this.CC(this.state.requirements.creatorAllowance)} <span className="swapcreate-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                    {this.state.requirements.checkResult[1] ? "✔️" : "❌"}
                  </p>
                  <p className="swapcreate-data">
                    <span className="swapcreate-data-bold">Creator's required {this.pairInfo[this.state.swapPair].tokenNameTo} Balance / Allowance : </span>
                    {this.state.toTokenFixed} <span className="swapcreate-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                  </p>
                  <p className="swapcreate-data">
                    <span className="swapcreate-data-bold">Taker's required {this.pairInfo[this.state.swapPair].tokenNameFrom} Balance / Allowance : </span>
                    {this.state.fromTokenFixed} <span className="swapcreate-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom}</span>
                  </p>
                  <br />
                  <p className="swapcreate-data">
                    <span className="swapcreate-data-bold">
                      Endpoint-based Requirement Check :
                  {this.state.requirements.checkResult[0] && this.state.requirements.checkResult[1]
                        ? " PASS ✔️" : " FAIL ❌"}
                    </span>
                  </p>
                  <br />
                  <p className="swapdetail-data">
                    <span className="swapdetail-data-bold">🔄 Swap Ratio : </span>
                  </p>
                  <p className="swapdetail-data">
                    1 <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo} : </span>
                    {toFromRatio} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom} </span>
                    //
                    1 <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameFrom} : </span>
                    {fromToRatio} <span className="swapdetail-data-bold">{this.pairInfo[this.state.swapPair].tokenNameTo}</span>
                  </p>
                </div>
              </div>
              <div className="swapdetail-buttondiv">
                  <button className="swapcreate-button button-white" onClick={() => { this.changeAllowance("APPLY", "TO") }}>Apply {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance</button>
                  <button className="swapcreate-button button-white" onClick={() => { this.changeAllowance("REMOVE", "TO") }}>Remove {this.pairInfo[this.state.swapPair].tokenNameTo} Allowance</button>
                </div>

                <p className="swapcreate-title"></p>
                <button className="swapcreate-final-button" onClick={() => { this.createSwapOrder() }}>Create Swap {this.isCallOkay()}</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SwapCreate;